import { useTranslation } from 'react-i18next'
import Button from '../../../components/ui/Button'
import FilterBar from '../../../components/ui/FilterBar'

interface Props {
  /** Hafta başlığı (ör. "12 – 18 Ekim 2026"). */
  title: string
  onToday: () => void
  onPrevious: () => void
  onNext: () => void
  onRefresh: () => Promise<unknown>
}

/**
 * Takvim araç çubuğu: "Bugün", ‹ ›, hafta başlığı ve paylaşılan `FilterBar`'ın "Yenile"si. Başlık
 * `aria-live`: hafta değişince ekran okuyucu yeni aralığı duyurur.
 */
export default function WeekToolbar({ title, onToday, onPrevious, onNext, onRefresh }: Readonly<Props>) {
  const { t } = useTranslation()
  const previous = t('agenda.week.previous')
  const next = t('agenda.week.next')
  return (
    <FilterBar
      className="ui-filterbar--standalone agenda-week-toolbar"
      controlsAlign="left"
      onRefresh={onRefresh}
    >
      <Button
        type="button"
        variant="secondary"
        label={t('agenda.week.today')}
        className="agenda-week-today"
        onClick={onToday}
      />
      <span className="agenda-week-nav">
        <Button
          type="button"
          text
          rounded
          icon="pi pi-chevron-left"
          aria-label={previous}
          title={previous}
          onClick={onPrevious}
        />
        <Button
          type="button"
          text
          rounded
          icon="pi pi-chevron-right"
          aria-label={next}
          title={next}
          onClick={onNext}
        />
      </span>
      <h2 className="agenda-week-title" aria-live="polite">
        {title}
      </h2>
    </FilterBar>
  )
}
